const CarSVG = (props: any) =>
  `<svg width="1096" height="1096" viewBox="0 0 1096 1096" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="547" cy="547" r="540" fill='${props.color}'/>
  <path fill="#fff" d="m308 490 52.5-157.5h385L798 490m-52.5 175a52.5 52.5 0 0 1-52.5-52.5 52.5 52.5 0 0 1 52.5-52.5 52.5 52.5 0 0 1 52.5 52.5 52.5 52.5 0 0 1-52.5 52.5m-385 0a52.5 52.5 0 0 1-52.5-52.5 52.5 52.5 0 0 1 52.5-52.5 52.5 52.5 0 0 1 52.5 52.5 52.5 52.5 0 0 1-52.5 52.5m434.7-350c-7-20.3-26.6-35-49.7-35h-385c-23.1 0-42.7 14.7-49.7 35L238 525v280a35 35 0 0 0 35 35h35a35 35 0 0 0 35-35v-35h420v35a35 35 0 0 0 35 35h35a35 35 0 0 0 35-35V525l-72.8-210Z"/>
</svg>
  `;

export default CarSVG;
